import { defineStore } from "pinia";
import http from "@/http";
import { LIST_FORNECEDOR, ADD_FORNECEDOR, UPDATE_FORNECEDOR, DEL_FORNECEDOR } from "@/http/url";

export const useFornecedorStore = defineStore("FornecedorStore", {
  state: () => {
    return {
      fornecedores: [],
      loaded: false,
    };
  },
  
  persist: { storage: sessionStorage },

  //Os actions não precisam das mutations, acessam diretamente o state
  actions: {
    LISTAR_FORNECEDORES() {
      return new Promise((resolve, reject) => {
        http
          .get(LIST_FORNECEDOR)
          .then((response) => {
            this.fornecedores = response.data;
            this.loaded = true;
            resolve("Ok");
          })
          .catch((erro) => {
            reject(erro);
          });
      });
    },

    CADASTRAR_FORNECEDOR(fornecedor) {
      return http
        .post(ADD_FORNECEDOR, fornecedor)
        .then((response) => this.fornecedores.push(response.data))
        .catch((erro) => {
          console.log(erro);
        });
    },

    ALTERAR_FORNECEDOR(fornecedor) {
      return http.put(`${UPDATE_FORNECEDOR + fornecedor.id}`, fornecedor);
    },

    REMOVER_FORNECEDOR(id) {
      return http
        .delete(`${DEL_FORNECEDOR + id}`)
        .then(() => (this.fornecedoreses = this.fornecedores.filter((forn) => forn.id != id)));
    },

  },

  //Os getters precisam do state para acesso externo aos componentes
  getters: {
    getFornecedores() {      
      return this.fornecedores;
    },

    getFornecedorLoad(state) {
      return state.loaded;
    },

    getFilterFornecedores: (state) => {
      return (filtro) => state.fornecedores.filter((f) => !filtro || f.nome.includes(filtro));
    },
  },
});